<template>
  <div>
    <card
      id="grid-item"
      ref="grid-item-wrapper"
    >
      <el-table
        class="table-striped"
        :header-cell-style="headerCellStyle"
        header-row-class-name="text-danger"
        :cell-style="cellStyle"
        :data="agenda.AgendaItems"
      >
        <el-table-column
          label="Start"
          prop="StartTime"
          :formatter="timeFormatter"
          width="70px"
        />
        <el-table-column
          v-if="agenda.AgendaType === 'Staff_Development'"
          label="Duration"
          prop="DurationMinutes"
          class-name="d-none d-md-table-cell text-center"
          width="100px"
        />
        <el-table-column
          label="Title"
          prop="Topic"
        />
        <el-table-column
          class-name="d-none d-md-table-cell"
          label="Presented By"
          width="130px"
        >
          <template slot-scope="props">
            {{ staff[props.row.PresenterScouterKey] }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="agenda.AgendaType === 'Staff_Development'"
          class-name="d-none d-md-table-cell"
          label="Notes"
          prop="Notes"
        />
        <el-table-column
          v-if="agenda.AgendaType === 'Course_Day'"
          class-name="d-none d-md-table-cell"
          label="Location"
          width="120px"
          prop="LocationInfo"
        />
        <el-table-column
          v-if="agenda.AgendaType === 'Course_Day'"
          class-name="d-none d-md-table-cell"
          label="Quartermaster"
        >
          <template slot-scope="props">
            <div v-html="props.row.QuartermasterInfo" />
          </template>
        </el-table-column>
        <el-table-column
          v-if="agenda.AgendaType === 'Course_Day'"
          label="Page"
          width="50px"
          class-name="d-none d-md-table-cell text-center"
          prop="CurriculumReference"
        />
        <el-table-column
          v-if="agenda.AgendaType === 'Course_Day'"
          label="Audience"
          width="70px"
          class-name="d-none d-md-table-cell text-center"
          prop="Audience"
        />
        <el-table-column
          v-if="agenda.AgendaType === 'Course_Day'"
          class-name="d-none d-md-table-cell"
          label="Notebook"
          prop="NotebookPages"
        />
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="right"
          width="120"
          label="Actions"
        >
          <template slot-scope="props">
            <p-button
              type="info"
              size="sm"
              class="mt-1 mb-1"
              title="Edit"
              icon
              @click="showEditDialog(props.row, props.$index)"
            >
              <i class="fa fa-edit" />
            </p-button>
            <p-button
              type="success"
              size="sm"
              class="mt-1 mb-1"
              title="Add Before"
              icon
              @click="showInsertAtDialog(props.$index)"
            >
              <i class="nc-icon nc-minimal-up" />
            </p-button>
            <p-button
              type="danger"
              size="sm"
              class="mt-1 mb-1"
              title="Delete"
              icon
              @click="deleteConfirm(props.row, props.$index)"
            >
              <i class="fa fa-times" />
            </p-button>
          </template>
        </el-table-column>
      </el-table>
      <p-button
        type="success"
        :disabled="disableButtons"
        @click="showAddAtEndDialog"
      >
        Add Topic at End
      </p-button>
    </card>
    <modal
      id="update-item"
      :show.sync="showAdd"
    >
      <div
        slot="header"
        class="ml-4"
      >
        <h6>
          <i class="fa fa-edit mr-2" /><span class="text-danger">{{ newItem.Id ? "Edit" : "Add" }} Agenda Item</span>
        </h6>
      </div>
      <ValidationObserver ref="itemForm">
        <form
          id="itemForm"
          @submit.prevent="save"
        >
          <ValidationProvider
            name="startTime"
            rules="required"
          >
            <fg-input
              slot-scope="{ errors }"
              :error="errors[0] ? 'Please select a Start Time for this Agenda Item': ''"
            >
              <label for="startTime">Start Time <span class="text-danger">*</span></label>
              <el-time-picker
                v-model="newItem.StartTime"
                format="h:mm a"
                value-format="yyyy-MM-ddTHH:mm:ss"
                :clearable="timeIsClearable"
                :picker-options="{ format: 'h:mm a'}"
              />
            </fg-input>
          </ValidationProvider>
          <ValidationProvider
            name="durationMinutes"
            rules="required"
          >
            <fg-input
              name="duration"
              label="Duration"
              required
              placeholder=""
              type="number"
              v-model="newItem.DurationMinutes"
              slot-scope="{ errors }"
              :error="errors[0] ? 'Please indicate the length of time alloted for this item.': ''"
            />
          </ValidationProvider>
          <fg-input>
            <p-checkbox v-model="cascadeStartTimes">
              Cascade Start Time Changes
            </p-checkbox>
          </fg-input>
          <ValidationProvider
            name="presentation"
            rules="presentation:@topic"
          >
            <fg-input
              slot-scope="{ errors }"
              :error="errors[0] ? 'Either the Topic or Presentation is required': ''"
            >
              <label>Presentation</label>
              <el-select
                class="select-default2"
                size="large"
                name="presentation"
                ref="presentation"
                placeholder="select either a presentation or enter a topic"
                @change="onSelectedPresentationIdChange"
                v-model="newItem.PresentationId"
              >
                <el-option
                  v-for="option in presentations"
                  class="select-default2"
                  :value="option.Id"
                  :label="option.Title"
                  :key="option.Title"
                />
              </el-select>
            </fg-input>
          </ValidationProvider>
          <ValidationProvider
            name="topic"
            rules="required_if:presentation,0,'',null"
            v-slot="{ passed, failed }"
          >
            <fg-input
              name="topic"
              label="Topic"
              ref="topic"
              :error="failed ? 'Either the Topic or Presentation is required': null"
              :has-success="passed"
              placeholder="select either a presentation or enter a topic"
              v-model="newItem.Topic"
            />
          </ValidationProvider>
          <fg-input>
            <label>Presenter</label>
            <el-select
              class="select-default2"
              size="large"
              name="presenter"
              placeholder=""
              v-model="newItem.PresenterScouterKey"
            >
              <el-option
                v-for="(value,data) in staff"
                class="select-default2"
                :value="data"
                :label="value"
                :key="value"
              />
            </el-select>
          </fg-input>
          <fg-input v-if="agenda.AgendaType==='Staff_Development'">
            <label for="notes">Notes</label>
            <ValidationProvider
              name="notes"
              rules="max:2000"
              v-slot="{ passed, failed }"
            >
              <textarea
                class="form-control"
                :error="failed ? '2000 character max': null"
                :has-success="passed"
                maxlength="2000"
                type="text"
                placeholder=""
                id="notes"
                v-model="newItem.Notes"
              />
            </ValidationProvider>
          </fg-input>
          <ValidationProvider
            name="quartermaster"
            rules="max:2500"
          >
            <fg-input
              v-if="agenda.AgendaType==='Course_Day'"
              slot-scope="{ errors }"
              :error="errors[0] ? '2500 character max': ''"
            >
              <label for="quartermaster">Quartermaster Info</label>
              <ckeditor
                :editor="editor"
                v-model="newItem.QuartermasterInfo"
                :config="editorConfig"
              />
            </fg-input>
          </ValidationProvider>
        </form>
      </ValidationObserver>
      <template slot="footer">
        <p-button
          type="danger"
          class="mr-2"
          @click="showAdd = false"
        >
          Cancel
        </p-button>
        <p-button
          type="success"
          native-type="submit"
          form="itemForm"
          class="mr-2"
        >
          Save
        </p-button>
      </template>
    </modal>
  </div>
</template>

<script>
import agendaItemApi from '@/services/api/agenda-item'
import presentationApi from '@/services/api/presentation'
import scouterApi from '@/services/api/scouter'
import Modal from '@/plugins/paper-components/modal.vue'
import { TimePicker } from 'element-ui'
import { extend } from 'vee-validate'
// eslint-disable-next-line camelcase
import { required, max, required_if } from 'vee-validate/dist/rules'
import pCheckbox from '@/plugins/paper-components/inputs/p-checkbox.vue'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import formatter from '@/services/formatter.js'
import dayjs from 'dayjs'

extend('required', required)
extend('max', max)
extend('required_if', required_if)
extend('presentation', {
  params: ['otherValue'],
  validate: (value, { otherValue }) => {
    if ((value === 0 || value === '0' || value === null || value === undefined) && (otherValue === null || otherValue === undefined || otherValue.trim() === '')) {
      return false
    } else {
      return true
    }
  }
})

export default {
  name: 'AgendaItemEdit',
  components: {
    Modal,
    [TimePicker.name]: TimePicker,
    pCheckbox,
    ckeditor: CKEditor.component
  },
  props: {
    agenda: {
      type: Object,
      default: function () {
        return {}
      }
    },
    agendaStartDate: {
      type: Date,
      default: null
    }
  },
  data: function () {
    return {
      cellStyleStaffDev: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyleStaffDev: { padding: '0', height: '20px', 'font-size': '10px', 'text-align': 'center', 'overflow-wrap': 'break-word' },
      cellStyleCourse: { padding: '0', height: '20px', 'font-size': '9px' },
      headerCellStyleCourse: { padding: '0', height: '20px', 'font-size': '9px', 'text-align': 'center', 'overflow-wrap': 'break-word' },
      staff: [],
      disableButtons: false,
      tempHolding: null,
      cascadeStartTimes: true,
      showAdd: false,
      timeIsClearable: false,
      editingIndex: null,
      editorConfig: {
        width: '100%'
      },
      editor: ClassicEditor,
      newItem: {
        AgendaId: 0,
        Description: null,
        DurationMinutes: null,
        Id: null,
        LocationInfo: null,
        Notes: null,
        PresenterScouterKey: null,
        QuartermasterInfo: null,
        StartTime: null,
        Topic: null
      },
      presentations: []
    }
  },
  computed: {
    headerCellStyle: function () {
      if (this.agenda.AgendaType === 'Staff_Development') {
        return this.headerCellStyleStaffDev
      } else if (this.agenda.AgendaType === 'Course_Day') {
        return this.headerCellStyleCourse
      } else {
        return ''
      }
    },
    cellStyle: function () {
      if (this.agenda.AgendaType === 'Staff_Development') {
        return this.cellStyleStaffDev
      } else if (this.agenda.AgendaType === 'Course_Day') {
        return this.cellStyleCourse
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.getStaffList()
    this.getPresentations()
  },
  methods: {
    getPresentations: function () {
      presentationApi.list(this.$root.courseKey)
        .then(x => {
          this.presentations = x
          const blank = {
            Id: 0,
            Title: ' '
          }
          this.presentations.unshift(blank)
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    getStaffList: function () {
      scouterApi.getStaffLookups(this.$root.courseKey)
        .then(y => {
          this.staff = y
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    timeFormatter: function (row, column, cellValue, index) {
      return formatter.formatAsTime(cellValue)
    },
    dateFormatter: function (row, column, cellValue, index) {
      return formatter.formatAsDateTime(cellValue)
    },
    showEditDialog: function (row, index) {
      this.newItem.AgendaId = row.AgendaId
      this.newItem.Audience = row.Audience
      this.newItem.CurriculumReference = row.CurriculumReference
      this.newItem.DurationMinutes = row.DurationMinutes
      this.newItem.Id = row.Id
      this.newItem.ItemDescription = row.ItemDescription
      this.newItem.LocationInfo = row.LocationInfo
      this.newItem.NotebookPages = row.NotebookPages
      this.newItem.Notes = row.Notes
      this.newItem.PresentationId = row.PresentationId
      this.newItem.PresenterScouterKey = row.PresenterScouterKey
      this.newItem.QuartermasterInfo = row.QuartermasterInfo
      this.newItem.StartTime = row.StartTime
      this.newItem.Topic = row.Topic
      this.editingIndex = index
      this.$refs.itemForm.reset()
      this.showAdd = true
    },
    onSelectedPresentationIdChange: function (value) {
      if (value && value !== 0) {
        this.newItem.Topic = null
      }
    },
    getAddItemStartTime: function (rowIndex) {
      if (this.agenda.AgendaItems && this.agenda.AgendaItems.length > 0) {
        if (rowIndex === null) {
          rowIndex = this.agenda.AgendaItems.length - 1
        }
        const previousMoment = dayjs(this.agenda.AgendaItems[rowIndex].StartTime)
        if (previousMoment.isValid()) {
          return previousMoment.add(this.agenda.AgendaItems[rowIndex].DurationMinutes, 'm').format('YYYY-MM-DDTHH:mm:ss')
        } else {
          return null
        }
      } else {
        if (this.agenda.StartDate !== null &&
          this.agenda.StartDate !== undefined) {
          return '1970-01-01T' + dayjs(this.agenda.StartDate).format('HH:mm:ss')
        } else {
          return null
        }
      }
    },
    showInsertAtDialog: function (index) {
      this.newItem.AgendaId = this.agenda.Id
      this.newItem.DurationMinutes = 0
      this.newItem.Audience = null
      this.newItem.CurriculumReference = null
      this.newItem.Id = null
      this.newItem.ItemDescription = null
      this.newItem.NotebookPages = null
      this.newItem.Notes = null
      this.newItem.PresentationId = null
      this.newItem.PresenterScouterKey = null
      this.newItem.QuartermasterInfo = null
      this.newItem.Topic = null
      this.newItem.StartTime = this.getAddItemStartTime(index - 1)
      this.$refs.itemForm.reset()
      this.editingIndex = index - 1
      this.showAdd = true
    },
    showAddAtEndDialog: function () {
      this.newItem.AgendaId = this.agenda.Id
      this.newItem.DurationMinutes = 0
      this.newItem.Audience = null
      this.newItem.CurriculumReference = null
      this.newItem.Id = null
      this.newItem.ItemDescription = null
      this.newItem.NotebookPages = null
      this.newItem.Notes = null
      this.newItem.PresentationId = null
      this.newItem.PresenterScouterKey = null
      this.newItem.QuartermasterInfo = null
      this.newItem.Topic = null
      this.newItem.StartTime = this.getAddItemStartTime(null)
      this.$refs.itemForm.reset()
      this.editingIndex = 999
      this.showAdd = true
    },
    save: function () {
      // we have to remove the GMT stuff off the date
      this.newItem.StartTime = this.newItem.StartTime.toLocaleString()
      this.tempHolding = this.newItem.StartTime
      return this.$refs.itemForm.validate().then(res => {
        if (res) {
          if (this.newItem.PresentationId !== null && this.newItem.PresentationId !== '' &&
              this.newItem.PresentationId !== '0' && this.newItem.PresentationId !== 0) {
            this.newItem = this.updateTitle(this.newItem)
          }
          let durationChange = 0
          if (this.editingIndex < this.agenda.AgendaItems.length - 1) {
            durationChange = this.determineDurationChange(this.newItem, this.editingIndex)
          }
          this.updateItem(this.newItem)
          if (this.cascadeStartTimes) {
            if (durationChange !== 0) {
              this.cascadeTimeUpdate(this.editingIndex, durationChange)
            }
          }
        }
        return res
      })
    },
    determineDurationChange: function (item, index) {
      const minutesMoved = Number(item.DurationMinutes) - Number(this.agenda.AgendaItems[index].DurationMinutes)
      const newStartMoment = dayjs(item.StartTime)
      const oldStartMoment = dayjs(this.agenda.AgendaItems[index].StartTime)
      const startMoved = newStartMoment.diff(oldStartMoment, 'm')

      return (startMoved + minutesMoved)
    },
    cascadeTimeUpdate: function (startRowIndex, addMinutes) {
      for (let ix = startRowIndex + 1; ix < this.agenda.AgendaItems.length; ix++) {
        this.agenda.AgendaItems[ix].StartTime = dayjs(this.agenda.AgendaItems[ix].StartTime).add(addMinutes, 'm').format('YYYY-MM-DDTHH:mm:ss')
        this.updateItem(this.agenda.AgendaItems[ix])
      }
    },
    updateTitle: function (item) {
      const p = this.getPresentation(item.PresentationId)
      if (p !== null) {
        item.Topic = p.Title
        item.PresenterScouterKey = p.PresenterScouterKey
        item.PresentationId = p.Id
        item.Audience = p.Audience
        item.CurriculumReference = p.CurriculumReference
        item.NotebookPages = p.NotebookPages
      }
      return item
    },
    getPresentation: function (id) {
      let returnValue = null
      for (let i = 0; i < this.presentations.length; i++) {
        if (this.presentations[i].Id === id) {
          returnValue = this.presentations[i]
          break
        }
      }
      return returnValue
    },
    updateItem: function (agendaItem) {
      this.disableButtons = true
      agendaItemApi.updateAgendaItem(this.$root.courseKey, agendaItem)
        .then(x => {
          this.agenda.AgendaItems = x
          // Notify that the Agenda End Time could have changed
          // Commented out for now since it does not work correctly.
          const theLast = x[x.length - 1]
          if (theLast.StartTime) {
            const agendaEndTime = dayjs(theLast.StartTime).add(theLast.DurationMinutes, 'm')
            this.$emit('new-end-time', agendaEndTime)
          }
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating your line item.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(z => {
          this.disableButtons = false
          this.showAdd = false
        })
    },
    deleteConfirm: function (row, index) {
      const msg = 'Are you sure you want to delete ' + row.Topic +
                '? This will move all of following items earlier by ' + row.DurationMinutes +
                ' minutes.'
      this.$confirm(msg, 'Are you sure?', {
        buttonSize: 'sm',
        centered: true
      }).then(() => {
        this.deleteAgendaItem(row, index)
      })
    },
    deleteAgendaItem: function (row, index) {
      this.disableButtons = true
      const negativeMinutes = -1 * row.DurationMinutes
      this.cascadeTimeUpdate(index, negativeMinutes)
      agendaItemApi.deleteAgendaItem(this.$root.courseKey, this.agenda.Id, row.Id)
        .then(x => {
          this.agenda.AgendaItems = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error deleting your line item.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(z => {
          this.disableButtons = false
        })
    }
  }
}
</script>
